import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET } from "../../../../event/model";

const NextOfKinInformation = ({ item, isAdmin }) => {
    const [next, setNext] = useState(undefined);
    useEffect(() => {
        if (item) setNext(next);
    }, [next, setNext, item]);
    EventEmitter.subscribe(EVENT_TARGET.kin, (event) => setNext(event));
    if (next)
        return (
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                            <strong>Name</strong>
                        </td>
                        <td>{next.name}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                            <strong>Phone No</strong>
                        </td>
                        <td>{next.telNumber}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                            <strong>Relation to Patient</strong>
                        </td>
                        <td>{next.relationship}</td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                            <strong>Address</strong>
                        </td>
                        <td>{next.address}</td>
                    </tr>
                </tbody>
            </table>
        );
    return isAdmin ? (
        <center>
            <NavLink
                to={{
                    pathname: `/home/patient/profile/${item.id}/add-next-of-kin`,
                    search: `?ref=${item.id}`,
                }}
                className="mdl-button mdl-js-button mdl-button--fab fab-mini"
            >
                <i className="material-icons text-success">add</i>
            </NavLink>
        </center>
    ) : null;
};
export default NextOfKinInformation;
